import React from 'react'
import { Route } from 'react-router'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { OrganizationsSearch } from './OrganizationsSearch'
import { ExperiencesBillingContainer } from './ExperiencesBilling'
import { OrganizationCollections } from './OrganizationCollections'
import { OrganizationChallenges } from './OrganizationChallenges'
import { LocaleProvider } from 'bundles/core/LocaleProvider'

const AppWrapper = ({ children }) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

export const routes = (
  <LocaleProvider>
    <Route component={AppWrapper}>
      <Route path='search' component={OrganizationsSearch} />
      <Route path=':organizationId/experiences_billing' component={ExperiencesBillingContainer} />
    </Route>
    <Route path=':clubIdParam/challenges' component={OrganizationChallenges} />
    <Route path=':clubIdParam/collections' component={OrganizationCollections} />
  </LocaleProvider>
)
